"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var modal_1 = __importDefault(require("relements/build/esm/overlays/modal"));
var api_1 = require("@src/api");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var const_1 = require("@src/const");
var BotActions_1 = require("@src/actions/BotActions");
var _utils_1 = require("@src/actions/_utils");
var constants_1 = require("./constants");
var reducer_1 = require("./reducer");
var actions_1 = require("./actions");
var ActivityCard_1 = __importDefault(require("./components/ActivityCard"));
var DownloadGlossary_1 = __importDefault(require("./components/DownloadGlossary"));
var UploadGlossary_1 = __importDefault(require("./components/UploadGlossary"));
var StatusBar_1 = __importDefault(require("./components/StatusBar"));
var utils_1 = require("./utils");
require("./BotGlossaryModal.scss");
var defaults = {
    active: false,
    toggleGlossaryModal: function () { return null; },
    domain: {},
};
/**
 * Modal which will be upload or download bulk users
 */
var BotGlossaryModal = function (_a) {
    var _b = _a === void 0 ? defaults : _a, active = _b.active, toggleGlossaryModal = _b.toggleGlossaryModal, domain = _b.domain;
    var _c = reducer_1.getReducer(), state = _c[0], dispatch = _c[1];
    var actions = actions_1.glossaryActions(dispatch);
    var statusBarData = state.statusBarData, downloadInitiated = state.downloadInitiated, uploadStatus = state.uploadStatus, disableUpload = state.disableUpload;
    // Download File
    var downloadFile = function () {
        actions.setDownloadInitiated(true);
        api_1.API.botGlossary
            .getBotGlossaryFile(domain.id)
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            actions.setDownloadInitiated(false);
            if (!success) {
                BotActions_1.createAlert(response.error || 'Error occurred while downloading file.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                return;
            }
            // eslint-disable-next-line camelcase
            utils_1.fileDownload(response, domain.title.toLowerCase() + "_glossary.csv");
            _utils_1.sendGoogleAnalyticsEvents(const_1.GOOGLE_ANALYTICS.CATEGORY.EDIT_BOT_GLOSSARY, const_1.GOOGLE_ANALYTICS.EVENTS.BOT_GLOSSARY_DOWNLOAD, "bot-" + domain.id, const_1.GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK);
        })["catch"](function (error) {
            api_1.captureException(error);
            actions.setDownloadInitiated(false);
        });
    };
    /**
     * Toggle status bar visibility on file upload
     * @param fileDetails The file details which are to be shown in the status bar
     */
    var toggleStatusBar = function (fileDetails) {
        var fileExists = fileDetails.fileName !== undefined;
        var statusData = {
            active: fileExists || !statusBarData.active,
            fileName: '',
            fileSize: '',
        };
        var fileStatusData = fileExists
            ? __assign(__assign({}, statusData), fileDetails) : statusData;
        actions.setStatusBarData(fileStatusData);
    };
    /**
     * Initiate File Upload
     * @param file File data to be uploaded
     */
    var uploadFile = function (file) {
        var fileDetails = {
            fileName: file.name,
            fileSize: utils_1.formatBytes(file.size),
        };
        toggleStatusBar(fileDetails);
        actions.setUploadStatus(constants_1.STATUS_TYPES.IN_PROGRESS);
        actions.setDisableUpload(true);
        var formData = new FormData();
        formData.append('glossary', file);
        api_1.API.botGlossary
            .uploadBotGlossaryFile(domain.id, formData)
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (!success) {
                BotActions_1.createAlert(response.error || 'Error occurred while uploading the file.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                actions.setUploadStatus(constants_1.STATUS_TYPES.ERROR);
                actions.setDisableUpload(false);
                return;
            }
            BotActions_1.createAlert(response.body, null, MogamboConstants_1.AlertTypes.POSTITIVE);
            actions.setUploadStatus(constants_1.STATUS_TYPES.COMPLETE);
            actions.setDisableUpload(false);
            _utils_1.sendGoogleAnalyticsEvents(const_1.GOOGLE_ANALYTICS.CATEGORY.EDIT_BOT_GLOSSARY, const_1.GOOGLE_ANALYTICS.EVENTS.BOT_GLOSSARY_UPLOAD, "bot-" + domain.id, const_1.GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK);
        })["catch"](function (error) {
            api_1.captureException(error);
            actions.setUploadStatus(constants_1.STATUS_TYPES.ERROR);
            actions.setDisableUpload(false);
        });
    };
    /**
     * Returns the current status bar icon based on current status
     * @param status Status code of the file upload
     */
    var statusBarIcon = function (status) {
        var loader = react_1["default"].createElement(loader_1["default"], { size: 14 });
        var iconName = status === constants_1.STATUS_TYPES.COMPLETE ? 'tick-green' : 'error_response';
        var icon = react_1["default"].createElement(icon_1["default"], { src: iconName });
        var renderIcon = loader;
        if (status !== constants_1.STATUS_TYPES.IN_PROGRESS) {
            renderIcon = icon;
        }
        return renderIcon;
    };
    // Render Modal Loader
    var renderModalLoader = function () { return (react_1["default"].createElement("div", { className: "modalLoader" },
        react_1["default"].createElement(loader_1["default"], null))); };
    var className = downloadInitiated && 'disabled';
    return (react_1["default"].createElement(modal_1["default"], { active: active, prefixClassName: "modalWrapper" },
        react_1["default"].createElement(modal_1["default"].Header, { prefixClassName: "modalWrapper-header", customCloseIcon: "closeV2", onClose: toggleGlossaryModal },
            react_1["default"].createElement("div", { className: "modalWrapper-header-title" }, "Edit Language Glossary")),
        downloadInitiated && renderModalLoader(),
        react_1["default"].createElement("div", { className: "botGlossaryModal " + className },
            react_1["default"].createElement("div", { className: "botGlossaryModal-content" },
                react_1["default"].createElement(ActivityCard_1["default"], { info: "Download a spreadsheet of the current glossary. Edit the glossary file and upload it back." },
                    react_1["default"].createElement(DownloadGlossary_1["default"], { onClick: downloadFile })),
                react_1["default"].createElement(ActivityCard_1["default"], { info: "Upload the updated file here and we will update it and also let you know if we find any errors." },
                    react_1["default"].createElement(UploadGlossary_1["default"], { onUpload: uploadFile, disableUpload: disableUpload }))),
            react_1["default"].createElement("div", { className: "botGlossaryModal-footer" },
                react_1["default"].createElement(StatusBar_1["default"], { active: statusBarData.active, fileName: statusBarData.fileName, fileSize: statusBarData.fileSize },
                    react_1["default"].createElement("div", { className: "statusBar-inner" },
                        statusBarIcon(uploadStatus),
                        react_1["default"].createElement("span", { className: "statusBar-current-text" }, uploadStatus),
                        react_1["default"].createElement(icon_1["default"], { src: "close", className: "statusBar-dismiss " + (uploadStatus !== constants_1.STATUS_TYPES.IN_PROGRESS && 'active'), onClick: toggleStatusBar })))))));
};
exports["default"] = BotGlossaryModal;
